export default {
  // Uncomment this will override the map object in language translation files
  // map: {
  //   status: {
  //     0: 'Deactivated',
  //     1: 'Active'
  //   }
  // }
};
